import { checkAdBlock } from 'adblock-checker';
import { Component, OnInit } from '@angular/core';
import data from '../../../../appsettings.json';

@Component({
  selector: 'app-adblock-detection',
  templateUrl: './adblock-detection.component.html',
  styleUrls: ['./adblock-detection.component.scss']
})
export class AdblockDetectionComponent implements OnInit {
  adBlockDetected: boolean = false;

  constructor() {}

  ngOnInit() {
    if (data.adBlockDetection) {
      this.adBlockDetectFunction();
    }
  }

  async adBlockDetectFunction() {
    checkAdBlock().then(adBlockDetected => {
      this.adBlockDetected = adBlockDetected;
    });
  }

  dismissOverlay() {
    location.reload();
  }
}
